import { Skeleton } from 'ui/skeleton';
import { FlexSpacer } from 'ui/flexSpacer';
import { spacing } from 'ui/theme';
import { GOAL_CARD_TEST_IDS } from './GoalCard.constants';
import { StyledDashboardCard } from './GoalCard.styled';

export const GoalCardLoading = () => {
  return (
    <StyledDashboardCard data-test={GOAL_CARD_TEST_IDS.CARD_LOADING} aria-label="Loading goal data">
      <Skeleton width={200} height={24} isRound isLoading />
      <Skeleton width={'100%'} height={200} isLoading />

      <FlexSpacer width={'100%'} height={56} justifyContent="flex-start" gap={spacing.base}>
        <Skeleton width={75} isRound isLoading />
        <Skeleton width={'100%'} isRound isLoading />
      </FlexSpacer>
    </StyledDashboardCard>
  );
};
